import { FormEvent, useEffect, useState } from 'react'
import { api } from 'core/api/ConnectionManager'
import moment from 'moment/moment'
import helpers from 'core/helpers'
import translate from 'core/translate'

export interface DisplayGroupTimezoneOption {
    id: string
    name: string
    gmtOffset: number
    timezoneAbbr: string
}

export interface IDisplaysAddGroupProps {
    groups: { id: number | string }[]
    data: Data
    setError: (error: string) => void
    closeModal: () => void
    clearData: () => void
    setPartialData: (data: SetPartialData) => void
    isEdit: boolean
    error: string
    timezones: DisplayGroupTimezoneOption[]
    unitList?: any
}
export type Data = {
    id: number
    parentId: number
    name: string
    timezone: string
    timezoneAbbr: string
    timezoneOffset: number
    inheritTimezone: boolean
    description: string
    scheduleIdToDelete: number[]
    DSNotificationsData?: { unitId: number | null; floorId: number | null } | null
}
export type SetPartialData = {
    scheduleIdToDelete?: number[]
    name?: string
    timezone?: string | null
    timezoneAbbr?: string
    timezoneOffset?: number
    parentId?: string | number
    inheritTimezone?: string | boolean
    description?: string
    DSNotificationsData?: { unitId: number | null; floorId: number | null } | null
}
export type Item = {
    startDate: string
    endDate: string
    startTime: string
    endTime: string
    repeatMode: string
    id: number
    broadcast: { title: string }
}

interface IState {
    groups: string[]
    schedules: {
        id: number
        broadcast: {
            title: string
        }
    }[]
    groupTimezone: boolean
    parentTimezone: string | null
    data?: {
        error?: string | null
    }
}

export const DisplaysAddGroupMethods = (p_: IDisplaysAddGroupProps) => {
    const [state, setState] = useState({
        groups: p_.groups.filter((group) => group.id !== p_.data.id),
        schedules: [],
        groupTimezone: false,
        parentTimezone: null,
        data: {
            error: null,
        },
    })

    useEffect(() => {
        api.send('getGroupSchedules', { groupId: p_.data.id }).then((res) => {
            setState((prevState: any) => {
                return { ...prevState, schedules: res }
            })
        })
    }, [])

    useEffect(() => {
        if (state.groupTimezone && p_.data && p_.data.parentId) {
            const parentTimezone: any = p_.groups.find((group) => group.id === p_.data.parentId)

            if (parentTimezone && parentTimezone['0'] && parentTimezone['1'] && parentTimezone['2']) {
                setState((prevState) => {
                    return {
                        ...prevState,
                        groupTimezone: true,
                        parentTimezone: parentTimezone['0'].timezone,
                        data: { ...prevState.data, nullTimezoneError: null },
                    }
                })

                p_.setPartialData({
                    timezone: parentTimezone['0'].timezone,
                    timezoneOffset: parentTimezone['1'].timezoneOffset,
                    timezoneAbbr: parentTimezone['2'].timezoneAbbr,
                })
            }
        }
    }, [state.groupTimezone])

    const groupScheduleInfo = (item: Item, type?: string) => {
        const startDate = moment(item.startDate).format('YYYY-MM-DD')
        const endDate = moment(item.endDate).format('YYYY-MM-DD')

        const startCell = helpers.getLocalDate({ date: startDate, time: item.startTime })
        let endCell: null | moment.Moment = helpers.getLocalDate({ date: startDate, time: item.endTime })

        if (item.repeatMode !== 'forever') {
            endCell = helpers.getLocalDate({ date: endDate, time: item.endTime })
        }

        if (type === 'date') {
            let endDateFormat: string | null = translate('forever')

            if (item.repeatMode !== 'forever') {
                endDateFormat = endCell ? moment(endCell).format('DD/MM/YYYY') : null
            }
            return `${startCell ? moment(startCell).format('DD/MM/YYYY') : null} - ${endDateFormat}`
        } else {
            return `${startCell ? moment(startCell).format('HH:mm') : null} - ${
                endCell ? moment(endCell).format('HH:mm') : null
            }`
        }
    }
    const submit = (e: FormEvent) => {
        const { setError, data, closeModal, clearData } = p_
        e.preventDefault()

        const groupInfo = { ...data }

        if (!groupInfo.name) {
            setState((prevState: any) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    error: 'fieldIsRequired',
                },
            }))

            return
        }

        api.send('editGroup', groupInfo)
            .then((groupItem) => {
                clearData()
                closeModal()
            })
            .catch((e) => setError('groupExistError'))
    }

    const inputNullCheck = (value: string | null, type: string) => {
        if (type === 'name') {
            value && !/^\s*$/.test(value)
                ? setState((prevState: any) => ({ ...prevState, data: { ...prevState.data, error: null } }))
                : setState((prevState: any) => ({
                      ...prevState,
                      data: { ...prevState.data, error: 'fieldIsRequired' },
                  }))
        }
    }

    const onClose = () => {
        const { closeModal, clearData } = p_

        clearData()
        closeModal()
    }

    return {
        state,
        setState,
        inputNullCheck,
        groupScheduleInfo,
        onClose,
        submit,
    }
}
